export function logout (queryParams = {}) {
  const urlSearchParams = new URLSearchParams(queryParams)
  const queryString = urlSearchParams.toString()

  window.location.href = '/gw/logout' + (queryString.length > 0 ? '?' : '') + queryString
}
